<script setup lang="ts">
    import Invoice from '@/app/invoicing/models/Invoice';

    const props = defineProps<{
        invoice: Invoice;
        defaultNextNumber: number;
        wantedNextNumber: number;
    }>();

    const nextNumberIsLater = computed(() => {
        return props.wantedNextNumber !== props.defaultNextNumber;
    });
</script>

<template>
    <div
        class="flex items-center px-5 py-4 mb-4 space-x-4 text-sm"
        :class="{ 'text-blue-900 bg-blue-200 rounded': true }"
    >
        <i class="text-2xl fa-regular fa-circle-info" />
        <div>
            <span class="block text-xs">
                {{ $t('invoicing.invoice_custom_internal_number_legal_reminder.text_1') }}
            </span>
            <span
                v-if="nextNumberIsLater"
                class="block text-xs"
            >
                {{ $t('invoicing.invoice_custom_internal_number_legal_reminder.text_2') }}
            </span>
        </div>
    </div>
</template>
